export class Utils {
    // calls function "myInitCode" when document is ready (even after document is already ready)
    static executeWhenDocumentIsReady(myInitCode: (() => void) | undefined): void {
        if (typeof myInitCode !== "function") {
            console.error('Provided parameter is not a function');
            return;
        }

        if (document.readyState !== 'loading') {
            myInitCode();
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                myInitCode();
            });
        }
    }
    public on(selector: string, event: string, handler: (e: Event) => void) {
        document.querySelectorAll(selector).forEach((element: Element) => {
            element.addEventListener(event, handler);
        });
    }
}

export const utils = new Utils();
